import { render, staticRenderFns } from "./LivingDemands.vue?vue&type=template&id=227f78b0&scoped=true&"
import script from "./LivingDemands.vue?vue&type=script&lang=js&"
export * from "./LivingDemands.vue?vue&type=script&lang=js&"
import style0 from "./LivingDemands.vue?vue&type=style&index=0&id=227f78b0&scoped=true&lang=css&"
import style1 from "./LivingDemands.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227f78b0",
  null
  
)

export default component.exports